import React from 'react';
import Navigation from './Navigation';

const Layout = ({ children }) => {
  return (
    <div className="App" style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Navigation />
      <main style={{
        flex: '1 0 auto',
        overflow: 'auto'
      }}>
        {children}
      </main>
      <footer style={{
        backgroundColor: '#1a1a1a',
        color: '#fff',
        textAlign: 'center',
        padding: '1rem',
        width: '100%'
      }}>
        <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} hamza. All rights reserved. Sole publisher and owner of this game.</p>
      </footer>
    </div>
  );
};

export default Layout;